import { useState } from 'react'
import { PillTabs } from '../../components/ui'
import { AdminAgents } from './AdminAgents'
import { AdminExternalAgents } from './AdminExternalAgents'
import { AdminAgentSafety } from './AdminAgentSafety'

// Model Pricing tab hidden for now — AdminModelPricing.tsx is untouched,
// just not wired into the tab list, so it's easy to bring back later.
const SUB_TABS = [
  { key: 'manage',   label: 'Manage' },
  { key: 'external', label: 'External Applications' },
  { key: 'safety',   label: 'Safety' },
] as const

type SubTab = typeof SUB_TABS[number]['key']

export function AdminAgentsHub() {
  const [sub, setSub] = useState<SubTab>('manage')

  return (
    <div>
      <PillTabs tabs={[...SUB_TABS]} active={sub} onChange={setSub} style={{ marginBottom: '1.25rem' }} />
      {sub === 'manage'   && <AdminAgents />}
      {sub === 'external' && <AdminExternalAgents />}
      {sub === 'safety'   && <AdminAgentSafety />}
    </div>
  )
}
